export default "__VITE_ASSET__09c922cd__"